import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import SiteHeader from '../../components/SiteHeader';
import { formatPrice } from '../../data/modules';
import { useModuleCatalog } from '../../data/useModuleCatalog';

const ModulesIndexPage = () => {
  const { modules } = useModuleCatalog();

  useEffect(() => {
    document.title = 'Modüller — QR Menü, QR Menü Pro, POS, Online Sipariş, Kurye, Sadakat, Cari, AI';

    const meta =
      document.querySelector('meta[name="description"]') ||
      (() => {
        const created = document.createElement('meta');
        created.setAttribute('name', 'description');
        document.head.appendChild(created);
        return created;
      })();
    meta.setAttribute(
      'content',
      'Cafe Otomasyonu modülleri: QR Menü (ücretsiz), QR Menü Pro, POS, Online Sipariş & Paket Servis, Kurye Takip, Sadakat Puanı, Cari & Finans ve Yapay Zeka. Yalnızca kullandığınız modülü ödersiniz.'
    );
  }, []);

  return (
    <>
    <SiteHeader />
    <main className="bg-white">
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-6xl mx-auto px-4">
          <h1 className="font-poppins font-heading-bold text-3xl md:text-5xl text-foreground mb-4">
            Modüller
          </h1>
          <p className="font-open-sans text-lg text-text-secondary max-w-3xl">
            Tek platform, ayrı ayrı açılabilen modüller. QR Menü sürekli ücretsiz; kalanları
            ihtiyacınız oldukça ekler, işinize yaramazsa kapatırsınız. Tüm modüller aynı veriyi
            kullanır — ürünü bir kez tanımlarsınız, her kanalda görünür.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {modules.map((module) => {
              const card = (
                <>
                  <div className="flex items-start justify-between mb-4">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${module.color}`}>
                      <Icon name={module.icon} size={24} className="text-white" />
                    </div>
                    {module.badge && (
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        module.badge === 'ÜCRETSİZ'
                          ? 'bg-green-100 text-green-700'
                          : module.badge === 'YAKINDA'
                            ? 'bg-gray-100 text-gray-600'
                            : 'bg-orange-100 text-orange-700'
                      }`}>
                        {module.badge}
                      </span>
                    )}
                  </div>

                  <h2 className="font-poppins font-heading-semibold text-lg text-foreground mb-1">
                    {module.name}
                  </h2>
                  <p className="font-open-sans text-xs text-text-secondary mb-3">
                    {module.subtitle}
                  </p>
                  <p className="font-open-sans text-sm text-text-secondary leading-relaxed mb-4">
                    {module.description}
                  </p>

                  <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between">
                    {module.purchasable ? (
                      <>
                        <span className="font-poppins font-heading-bold text-lg text-foreground">
                          {formatPrice(module.price.monthly)}
                          {module.price.monthly > 0 && (
                            <span className="font-open-sans text-xs text-text-secondary"> /ay</span>
                          )}
                        </span>
                        <span className="inline-flex items-center space-x-1 text-primary font-inter font-accent-semibold text-sm">
                          <span>İncele</span>
                          <Icon name="ArrowRight" size={14} />
                        </span>
                      </>
                    ) : (
                      /* Satışa kapalı modülün FİYATI GÖSTERİLMİYOR — alınamayan bir şeyin
                         fiyatını göstermek talep yaratıp karşılığını verememek olurdu. */
                      <span className="font-open-sans text-sm text-text-secondary">
                        Satışa açılmadı
                      </span>
                    )}
                  </div>
                </>
              );

              const baseClass =
                'flex flex-col h-full p-6 rounded-2xl border bg-white transition-all duration-300';

              return module.path ? (
                <Link
                  key={module.id}
                  to={module.path}
                  className={`${baseClass} border-gray-200 hover:border-primary/40 hover:shadow-lg`}
                >
                  {card}
                </Link>
              ) : (
                <div
                  key={module.id}
                  className={`${baseClass} border-dashed border-gray-300 bg-gray-50/60`}
                >
                  {card}
                </div>
              );
            })}
          </div>

          <div className="mt-12 text-center">
            <a
              href="https://panel.cafeotomasyonu.com/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-8 py-4 rounded-lg bg-primary text-white font-poppins font-cta-semibold"
            >
              <Icon name="ExternalLink" size={20} />
              <span>Ücretsiz Hesap Aç</span>
            </a>
          </div>
        </div>
      </section>
    </main>
    </>
  );
};

export default ModulesIndexPage;
